import React from 'react';

const PageFooter = () => {
  return (
    <footer id='footer'>
      <p>yabu &copy; {new Date().getFullYear()}</p>
    </footer>
  );
};

export default PageFooter;
